import script from "./btm.vue?vue&type=script&setup=true&lang=js"
export * from "./btm.vue?vue&type=script&setup=true&lang=js"

import "./btm.vue?vue&type=style&index=0&id=3e704f8b&lang=less&scoped=true"

import exportComponent from "D:\\aj项目\\code\\标准版观众登记英文\\visitor-regist-en_-standard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e704f8b"]])

export default __exports__